import styled, { keyframes } from "styled-components"

export const Container = styled.div`
  height: 100%;
  p {
    margin-bottom: 4.3rem;
  }
`

export const InputContainer = styled.div`
  display: grid;
  grid-template-columns: 3fr 3fr 1fr;
  gap: 1rem;
  position: relative;

  button {
    height: 4.4rem;
  }
`

export const Label = styled.h2`
  margin-bottom: 3.4rem;
`

export const DisplayNameRowWrapper = styled.div`
  padding: 1rem;
  background: ${({ theme }) => theme.colors.white};
  border-radius: 0.6rem;
  border: 1px solid ${({ theme }) => theme.colors.borderLight};
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
  position: relative;
`

export const ShowMoreButton = styled(DisplayNameRowWrapper)`
    justify-content: center;
    font-weight: 700;
    cursor: pointer;
    &:hover {
        background: ${({ theme }) => theme.colors.background};
    }
`

export const DisplayNameWrapper = styled.div`

    div {
        display: flex;
        align-items: center;
    }

    svg {
        height: 1.4rem;
        margin-right: 0.5rem;
    }
`

export const ButtonWrapper = styled.div`
display: flex;
`

export const GlobeIconWrapper = styled.div`
  margin-right: 0.3rem;
`

export const InputWrapper = styled.div`
display: flex;
  align-items: center;
  justify-content: center;

  div {
    padding: 0;
  }
`

export const Update = styled.div`
  margin-left: 1rem;
  border: 1px solid ${({ theme }) => theme.colors.borderLight};
  border-radius: 50%;
  height: 3rem;
  width: 4rem;
  display: flex;
  justify-content: center;

  svg {
    height: 1.4rem;
    margin: 0
  }

  &:hover {
    cursor: pointer;
    background: ${({ theme }) => theme.colors.background};
  }
`

const fadeInScale = keyframes`
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`

export const Unsaved = styled.div`
  position: absolute;
  padding: 0.2rem 1rem;
  border-radius: 0.6rem;
  font-size: 1.2rem;
  right: 12rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.white};
  background: ${({ theme }) => theme.colors.turquoiseDark};
  display: flex;
  align-items: center;
  animation: ${fadeInScale} 0.5s ease-out;
  cursor: default;

  svg {
    height: 1.4rem;
    margin-right: 0.5rem;
    fill: ${({ theme }) => theme.colors.white};
  }
`

export const KeyExists = styled.div`
  position: absolute;
  top: 4.4rem;
  left: 0.5rem;
  color: ${({ theme }) => theme.colors.error.highlight};
  font-size: 1.2rem;
`

